import app from '../app';

app.factory('latestBackendResponseInterceptor', ['$q', '$injector', 'latestBackendResponseService', function($q, $injector, latestBackendResponseService) {
  return {
    response: res => {
      latestBackendResponseService.conditions.forEach(function(condition) {
        condition.checkMatch(res);
      });

      return res;
    }
  };
}]);
